import React, {useEffect, useState  } from "react";
import "../Admin/css/dashboard.css";
import Sidebar from "./Sidebar";
import "../Admin/css/layout.css";
import { FaRupeeSign, FaUsers, FaChartLine, FaBullseye } from "react-icons/fa";
import Header from "./Header";
import { getPayments, getLastWorkStatus } from "../service/dashboardService.js"; 
import { getComplaints } from "../service/complaintService.js";
import { secureStorage } from "../utils/secureStorage";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { FaClock } from "react-icons/fa";


const Dashboard = () => {

    const navigate = useNavigate();
  const scholar = secureStorage.getScholar();
  const [complaints, setComplaints] = useState([]);
  const [loading, setLoading] = useState(true);
  const scholarId = scholar?.id;
  const [workStatus, setWorkStatus] = useState(null);
  //const [workProgress] = useState(65);
  // const [progressData, setProgressData] = useState({
  //   progress: 0,
  //   completedTasks: 0,
  //   totalTasks: 0
  // });
  const [paymentSummary, setPaymentSummary] = useState({
  totalPaid: 0,
  pendingAmount: 0
});

const [lastPayment, setLastPayment] = useState(null);

useEffect(() => {
   if (scholarId) {
  fetchPayments();
  fetchComplaints();
  fetchLastWorkStatus();
   }
}, [scholarId]);

 const fetchComplaints =  async () => {
    try {
        setLoading(true);
      if (!scholarId) return;

      const res = await getComplaints(scholarId);

      const list = res.data?.data || [];

      setComplaints(list);

    } catch (err) {
      console.error("FETCH ERROR:", err.response?.data);
    }
     finally {
      setLoading(false);
    }
  };

  const fetchPayments = async () => {
  try {
    const scholarId = scholar?.id;
    if (!scholarId) return;

    const res = await getPayments(scholarId);
    const payments = res.data?.data || [];

    if (payments.length > 0) {

      // latest payment
      const latestPayment = payments[0];

      setPaymentSummary({
        totalPaid: Number(latestPayment.tot_paid || 0),

        // balance amount
        pendingAmount: Number(latestPayment.bal_amt || 0),
      });

      // store latest payment details
      setLastPayment(latestPayment);

    } else {
      setPaymentSummary({
        totalPaid: 0,
        pendingAmount: 0,
      });

      setLastPayment(null);
    }

  } catch (err) {
    console.error(
      "Payment API Error:",
      err.response?.data || err.message
    );
  }
};

const fetchLastWorkStatus = async () => {
  try {
    if (!scholarId) return;

    const res = await getLastWorkStatus(scholarId);
    console.log("Last Work Status Response:", res.data);
    const statusData = res.data?.data.status || {};
    console.log("Extracted Work Status Data:", statusData);

    setWorkStatus(statusData  );

  } catch (err) {
    console.error(
      "Work Status API Error:",
      err.response?.data || err.message
    );
  }
};


  const statses = [
    { label: "Total Complaints", value: complaints.length },
    { label: "Pending", value: complaints.filter(c => c.status === "Pending").length },
    { label: "In Progress", value: complaints.filter(c => c.status === "In Progress").length },
    { label: "Resolved", value: complaints.filter(c => c.status === "Resolved").length },
  ];

  useEffect(() => {
  const scholar = secureStorage.getScholar();

  if (!scholar) {
    navigate("/", { replace: true });
  }
}, [navigate]);

   
   if (loading) {
    return (
      <>
        <div className="layout">
          <Sidebar />
          <div className="main-area">
            <Header />
        <div className="modern-loader-container">
     <div className="modern-loader-card">
    <div className="modern-loader-animation">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <h3>Loading Dashboard</h3>
    <p>Please wait while we fetch your dashboard details...</p>
  </div>
</div>
          </div>
        </div>
      </>
    );
  }



  return (
    <>
     <div className="layout">
        <Sidebar/>
         <div className="main-area">
    <Header/>
     
    <div className="dashboard-container">
    <div className="dashboard">
      <h2 className="dashboard-title">Welcome Back, Maathangi Info Research Solutions Pvt Ltd. Scholar!</h2>
<div className="card-container">

  {/* Pending Payment */}
  <div className="card modern clickable-card"  onClick={() => navigate("/payment")}>
    <div className="card-top">
      <h4>Outstanding Balance</h4>
      <div className="icon-circle">
        <FaRupeeSign />
      </div>
    </div>
    <h2 className="amount">
      <span className="rupee-icons">₹</span> {paymentSummary.pendingAmount}
    </h2>

    {/* <p className="trend positive">↗ 8.5% Last Month</p> */}
  </div>

  {/* Total Paid */}
  <div className="card modern clickable-card" onClick={() => navigate("/payment")}>
    <div className="card-top">
      <h4>Total Paid</h4>
      <div className="icon-circle">
        <FaChartLine />
      </div>
    </div>

    <h2 className="amount">
       <span className="rupee-icon">₹</span> {paymentSummary.totalPaid}
    </h2>

    {/* <p className="trend negative">↘ 2.5% Last Month</p> */}
  </div>

  {/* Resolved Complaints */}
  <div className="card modern clickable-card" onClick={() => navigate("/complaintregister")}>
    <div className="card-top">
      <h4>Resolved Complaints</h4>
      <div className="icon-circle">
        <FaUsers />
      </div>
    </div>

    <h2> <FaCheckCircle className="resolved-count-icon" />{" "}
    {statses?.[3]?.value || 0}</h2>

    {/* <p className="trend positive">↗ 5% Improvement</p> */}
  </div>

  {/* Pending Complaints */}
  <div className="card modern clickable-card" onClick={() => navigate("/complaintregister")}>
    <div className="card-top">
      <h4>Pending Complaints</h4>
      <div className="icon-circle">
        <FaBullseye />
      </div>
    </div>

    <h2><FaClock className="pending-count-icon" />{" "}
    {statses?.[1]?.value || 0}</h2>

    {/* <p className="trend positive">↗ 10% Completion</p> */}
  </div>



</div>

<div className="progress-wrapper-modern">

  <div className="progress-header-modern">
    <div>
      <h3>Project Completion</h3>
      <p>Track your research progress</p>
    </div>

    <div className="progress-circle">
       {workStatus || 0}%
    </div>
  </div>

  {/* Progress Bar */}
  <div className="progress-bar-modern">
    <div
      className="progress-fill-modern"
     style={{ width: `${workStatus || 0}%` }}
    >
    </div>
  </div>

  {/* Footer Stats */}
  <div className="progress-footer-modern">

    {/* <div className="progress-box completed">
      <CheckCircle size={18} />
      <div>
        <span>Completed</span>
        <strong>42 Tasks</strong>
      </div>
    </div> */}

    {/* <div className="progress-box remaining">
      <Clock size={18} />
      <div>
        <span>Remaining</span>
        <strong>23 Tasks</strong>
      </div>
    </div> */}

  </div>

</div>
    </div>
    <div className="payment-complaint-div">
   <div className="last-payment-card">

  <div className="last-payment-header">
    <h3>Last Payment Details</h3>
  </div>

  {lastPayment ? (
    <div className="last-payment-body">

      <div className="payment-detail-row">
        <span>Last Payment Date </span>
        <strong style={{ fontSize: "15px" }}>
         {new Date(lastPayment.pay_dt_tm)
  .toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })
  .replace("-")}
        </strong>
      </div>

      <div className="payment-detail-row">
        <span>Payment Paid for  </span>
       <strong style={{ fontSize: "15px" }}>
        {lastPayment?.purpose?.pay_purpose || "N/A"}
       </strong>
      </div>

      <div className="payment-detail-row">
        <span>Last Payment  </span>
        <strong className="payment-amount" style={{ color: "#4CAF50", fontSize: "1.2em" }}>
         ₹{Number(lastPayment.pay_received).toLocaleString("en-IN")}
        </strong>
      </div>

    </div>
  ) : (
    <p>No payment details found</p>
  )}

</div>
<div className="last-complaints-card">

  <div className="last-complaints-header">
    <h3>Recent Complaints</h3>
  </div>

  {complaints.length > 0 ? (
    <div className="last-complaints-body" onClick={() => navigate("/complaintregister")}>

      {complaints.slice(0, 2).map((item, index) => (
        <div className="complaint-item" key={index}>

          <div className="complaint-top">
            <h4>{item.subject || "Complaint"}</h4>

            <span
              className={`complaint-status ${
                item.status === "Resolved"
                  ? "resolved"
                  : item.status === "Pending"
                  ? "pending"
                  : "progress"
              }`}
            >
              {item.status}
            </span>
          </div>

         <p className="complaint-message">
  {(item.complaint || item.message || "No complaint message")
    .slice(0, 20)}
  {(item.complaint || item.message || "").length > 20 && "..."}
</p>

          <div className="complaint-date">
           {item.created_at
  ? new Date(item.created_at).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    })
  : "N/A"}
          </div>

        </div>
      ))}

    </div>
  ) : (
    <p className="no-complaints">
      No complaint details found
    </p>
  )}

</div>
</div>

    </div>
    
    </div>
    
    </div>
    </>
  );
};

export default Dashboard;